"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseOsName = void 0;
const osName_1 = require("../types/osName");
const parseOsName = (userAgent) => {
    if (!userAgent) {
        return undefined;
    }
    const ua = userAgent.toLowerCase();
    if (ua.includes('iphone') || ua.includes('ipad')) {
        return osName_1.AnalyticsOsNameEnum.IOS;
    }
    if (ua.includes('android')) {
        return osName_1.AnalyticsOsNameEnum.ANDROID;
    }
    if (ua.includes('mac')) {
        return osName_1.AnalyticsOsNameEnum.MACOS;
    }
    if (ua.includes('windows')) {
        return osName_1.AnalyticsOsNameEnum.WINDOWS;
    }
    if (ua.includes('linux')) {
        return osName_1.AnalyticsOsNameEnum.LINUX;
    }
    return osName_1.AnalyticsOsNameEnum.OTHER;
};
exports.parseOsName = parseOsName;
